var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteOrderNoteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.96086 1.09375H3.31151C2.6875 1.09375 2.18164 1.6109 2.18164 2.24883V9.75685C2.18164 10.3948 2.6875 10.9119 3.31151 10.9119H8.96086C9.58487 10.9119 10.0907 10.3948 10.0907 9.75685V2.24883C10.0907 1.6109 9.58487 1.09375 8.96086 1.09375Z",
    stroke: "#FCFAFA",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44141 3.98438H7.83102M4.44141 6.29454H7.83102M4.44141 8.6047H6.70115",
    stroke: "#FCFAFA",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteOrderNoteIcon);
export default __webpack_public_path__ + "static/media/white_OrderNote_Icon.2a814290cc2c90224c67b33a093e3fa0.svg";
export { ForwardRef as ReactComponent };